<template>
    <span>
      <b-nav-item
          to="/home"
      ><i class="fa mr-2 fa-home text-black" font-scale="1"></i>Home
      </b-nav-item>
        <router-link
            is="router-link"
            class="nav-item"
            to="/search">
            <a class="sidebar-menu-item nav-link">
                <template>
                    <i class="fa fa-search text-success pr-2"></i>
                    <span class="nav-link-text">
                        Search
                    </span>
                </template>
            </a>
        </router-link>
    </span>
</template>
<script>
export default {
  name: 'side-home-mobility-group'
}
</script>
